export const filterVariant = {
  root: {
    gap: 0.25,
  },
  list: {
    backgroundColor: 'neutral.900',
    gap: 0.25,
  },
  trigger: {
    backgroundColor: 'neutral.850',
    display: 'flex',
    flexDirection: 'column',
    color: 'neutral.white',
    borderBottom: '4px solid',
    borderBottomColor: 'transparent',
    _selected: {
      backgroundColor: 'blue.700',
      borderBottomColor: 'blue.500',
    },
    _hover: {
      backgroundColor: 'neutral.600',
      color: 'neutral.white',
      _selected: {
        backgroundColor: 'blue.700',
      },
    },
    _disabled: {
      backgroundColor: 'neutral.700',
      borderBottomColor: 'neutral.700',
      color: 'neutral.300',
      _hover: {
        backgroundColor: 'neutral.700',
        color: 'neutral.300',
      },
    },
  },
  contentGroup: {
    backgroundColor: 'neutral.900',
  },
  content: {
    backgroundColor: 'transparent',
  },
};
